import type { ExternalCollaboratorEntitlementQuery } from './__types__/ExternalCollaboratorEntitlementQuery';

export const getExternalCollaboratorEntitlementFromQuery = (
	queryData: ExternalCollaboratorEntitlementQuery | undefined,
): boolean | undefined => {
	return queryData?.entitlements.externalCollaborator.isEntitled;
};
